import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function HomePage(props) {
    const [query, setQuery] = useState("");
    const questions = require("../contents/questions.json");
    const quiz = questions[(props?.question || 1) - 1];
    const researchTopic = quiz.question;
    const backgroundImage = quiz.image ? `url('/image/${quiz.image}')` : "url('https://images.unsplash.com/photo-1736077722346-31ba59414728?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')";

    return (
        <div className="h-screen w-full flex flex-col items-center justify-center bg-gray-50">
            {/* Background Image with Fade */}
            <div className="absolute top-0 left-0 w-full h-3/5 bg-cover bg-center" style={{ backgroundImage }}>
                <div className="w-full h-full bg-gradient-to-b from-transparent to-gray-50"></div>
            </div>

            {/* Content Container */}
            <div className="relative flex flex-col items-center justify-center mt-20 max-w-6xl w-full">
                <h2 className="text-2xl font-semibold text-gray-700 mb-4 text-center">Question {props.question}</h2>
                <h1 className="text-2xl font-bold text-blue-700 mb-8 text-center">{researchTopic}</h1>
                <form onSubmit={() => props.handleSearch(query)} className="flex flex-col items-center w-full">
                    <input
                        type="text"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        className="py-2 px-4 w-4/5 text-lg border border-gray-300 rounded-full mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        placeholder="Enter your search query"
                    />
                    <button
                        type="submit"
                        disabled={query.length == 0}
                        className={`px-4 py-2 text-lg text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-400 ${
                            query.length > 0 ? "bg-blue-500 hover:bg-blue-600" : "bg-gray-300 cursor-not-allowed"
                        }`}>
                        Search
                    </button>
                </form>
            </div>
        </div>
    );
}

export default HomePage;
